import { render, staticRenderFns } from "./MainHud.vue?vue&type=template&id=01f0ffb5&"
import script from "./MainHud.vue?vue&type=script&lang=js&"
export * from "./MainHud.vue?vue&type=script&lang=js&"
import style0 from "./MainHud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports